export default __webpack_public_path__ + "static/media/kma-logo.0b9542f0.png";